module.exports = __webpack_public_path__ + "img/12-sdg-full@2x.abe8cceb.png";